<template>
    <el-select
            :placeholder="i18n.tkey('lang_product_unit')"
            :size="'large'"
            :filterable="false"
            v-model="selectCode"
            @change="changeSelect"
            v-loading="loading"
            :disabled="readOnly === true"
    >
        <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="(userInfoRef.lang == 'zh' || userInfoRef.lang == 'szh') ? item.description : item.description2"
                :value="item.unitCode"
        />
    </el-select>
</template>

<script setup>
    import {inject, ref, onBeforeMount, toRef, watch} from "vue";
    import {useCompanyinfo} from "@/stores/companyinfo";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import {useUserinfo} from "@/stores/userinfo";

    const props = defineProps(['modelValue', "readOnly"])
    const emits = defineEmits(['update:modelValue'])

    const i18n = inject("i18n")
    const loading = ref(false)

    const selectCode = ref(null)
    const unitList = ref([])

    const userInfoRef = toRef(useUserinfo())
    //響應機制的companyinfo
    const companyInfoRef = toRef(useCompanyinfo())

    const shopCompany = ref({})
    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return companyInfoRef.value } })

    watch(() => props.modelValue, (newValue, oldValue) => {
        selectCode.value = newValue
    })

    function getUnitcodeList(){
        loading.value = true

        const request = eshopopeeApi.getUnit
        const params = request.getParams()

        params.CompanyCode = shopCompany.value.acccompanycode

        request.send(params, (res) => {
            loading.value = false
            if (null != res){
                unitList.value = res
            }else{
                unitList.value = []
            }
        })

    }

    function changeSelect(value){
        emits("update:modelValue", value)
    }

    function reloadOption(){
        getUnitcodeList()
    }

    defineExpose({
        reloadOption
    })

    onBeforeMount(() => {
        shopCompany.value = getShopCompanyObj()
        selectCode.value = props.modelValue

        getUnitcodeList()

    })
</script>

<style scoped>

</style>